import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then((reg) => {

      const notifyUpdate = () => {
        window.dispatchEvent(new CustomEvent('swUpdateReady', { detail: { reg } }));
      };

      // A new SW is already waiting (e.g. tab was open during deploy)
      if (reg.waiting) {
        notifyUpdate();
        return;
      }

      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            notifyUpdate();
          }
        });
      });

    }).catch(() => {});
  });
}
